import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export const useGuestLoad = (path) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(() => {
    setError(null);
    api.get(path)
      .then((r) => setData(r.data))
      .catch((err) => {
        const status = err.response?.status;
        setError(status === 404 || status === 403 ? "invalid" : "transient");
      });
  }, [path]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (error !== "transient") return;
    const t = setTimeout(load, 5000);
    return () => clearTimeout(t);
  }, [error, load]);
  return { data, error, load };
};
